import { isEmpty, not } from 'ramda';
import type { PropsWithChildren } from 'react';
import React from 'react';

import { FeaturePicker } from '@/features/execute-calculation-set/components/ArcGisMapContainer/FeaturePicker/FeaturePicker';
import { useActions } from '@/overmind';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

export const EsriFeaturePicker: React.FunctionComponent<
  PropsWithChildren<{
    features: any[];
    graphics: any[];
    mapInteractionLocation: { x: number; y: number };
  }>
> = props => {

  const handleGridElementSelected = useActions().calculation.handleGridElementSelected;
  const featuresToPickFrom = props.features as any;
  const anyFeaturesToPickFrom = not(isEmpty(featuresToPickFrom));
  const [isPickingFeatures, setIsPickingFeatures] = React.useState(
    anyFeaturesToPickFrom
  );

  React.useEffect(() => {
    setIsPickingFeatures(anyFeaturesToPickFrom);
  }, [anyFeaturesToPickFrom, featuresToPickFrom]);


  const onFeatureSelected = (newSelected: FeatureWithIDs) => {
      setIsPickingFeatures(false);
      handleGridElementSelected(newSelected.gc.globalId);
    };

  return (
    <>
      {isPickingFeatures ? (
        <>
          <FeaturePicker
            featuresToPickFrom={{
              features: featuresToPickFrom,
              mapInteractionLocation: props.mapInteractionLocation
            }}
            onSelected={onFeatureSelected}
            onClose={() => {}}
          />
        </>
      ) : null}
    </>
  );
};
